import type { AssignmentRateOverrides } from '@core/job/assignmentRateOverrides.type';

export interface AssignmentRateInput {
  useCustomWorkerPayRate: boolean;
  workerPayRateDollars: string;
  useCustomClientPayRate: boolean;
  clientPayRateDollars: string;
}

export type AssignmentRateInputsByWorkerId = Record<
  string,
  AssignmentRateInput
>;

export const EMPTY_ASSIGNMENT_RATE_INPUT: AssignmentRateInput = {
  useCustomWorkerPayRate: false,
  workerPayRateDollars: '',
  useCustomClientPayRate: false,
  clientPayRateDollars: '',
};

const dollarsToCents = (dollars: string): number | null => {
  const trimmedDollars = dollars.trim();
  if (!/^\d+(\.\d{1,2})?$/.test(trimmedDollars)) {
    return null;
  }

  const cents = Math.round(Number(trimmedDollars) * 100);
  return cents > 0 ? cents : null;
};

export const getAssignmentRateOverrides = (
  rateInput: AssignmentRateInput | undefined,
): AssignmentRateOverrides | undefined => {
  if (!rateInput) {
    return undefined;
  }

  const finalWorkerPayRateCents = rateInput.useCustomWorkerPayRate
    ? dollarsToCents(rateInput.workerPayRateDollars)
    : undefined;
  const finalClientPayRateCents = rateInput.useCustomClientPayRate
    ? dollarsToCents(rateInput.clientPayRateDollars)
    : undefined;

  if (
    (rateInput.useCustomWorkerPayRate && finalWorkerPayRateCents === null) ||
    (rateInput.useCustomClientPayRate && finalClientPayRateCents === null)
  ) {
    throw new Error('Enter valid custom assignment rates');
  }

  if (
    finalWorkerPayRateCents === undefined &&
    finalClientPayRateCents === undefined
  ) {
    return undefined;
  }

  return {
    finalWorkerPayRateCents,
    finalClientPayRateCents,
  };
};
